var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResultForm',{attrs:{"data":_vm.data,"isNew":false,"isLoading":_vm.isLoading},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }